import Transition from './Transition';

/**
 * FadeTransitions
 *
 * @class
 * @augments Transition
 */
class FadeTransition extends Transition {
  /**
   * @constructor
   *
   * @param { jQuery } $element
   * @param { int } duration in ms
   * @param { int } delay in ms
   */
  constructor($element, duration, delay = 0) {
    super($element, duration, delay);

    this._animInClass = 't-fade-in';
    this._animOutClass = 't-fade-out';
  }
}

export default FadeTransition;
